import * as api from 'Shared/api/onboardingState';
import { handleError } from 'Shared/helpers';

import WpToastManager from 'Wpds/components/toast/WpToastManager';

import OnboardingStateConstants from '../constants/OnboardingState.constants';

export const advanceOnboardingStateSuccess = payload => ({
  type: OnboardingStateConstants.Actions.ADVANCE_ONBOARDING_STATE_SUCCESS,
  payload,
});

export const updateOnboardingStateSuccess = payload => ({
  type: OnboardingStateConstants.Actions.UPDATE_ONBOARDING_STATE_SUCCESS,
  payload,
});

export const backOnboardingStateSuccess = payload => ({
  type: OnboardingStateConstants.Actions.BACK_ONBOARDING_STATE_SUCCESS,
  payload,
});

export const updateTopicInReduxSuccess = payload => ({
  type: OnboardingStateConstants.Actions.UPDATE_TOPICS_IN_REDUX,
  payload,
});

function onSuccess(dispatch) {
  return response => dispatch(advanceOnboardingStateSuccess(response.data));
}

function onError(dispatch) {
  return error => dispatch(handleError(error));
}

export const advanceOnboardingStateAction = ({ onboardingState, didSkip }) => dispatch => {
  if (onboardingState?.profile || onboardingState?.kudos)
    return api
      .advanceOnboardingStateAsFormData({ onboardingState, didSkip })
      .then(onSuccess(dispatch), onError(dispatch));

  return api.advanceOnboardingState({ onboardingState, didSkip }).then(onSuccess(dispatch), onError(dispatch));
};

export const updateOnboardingStateFlowTypeAction = ({ flowType, shouldUpdateRedux = true }) => dispatch => {
  const data = {
    flow_type: flowType,
  };
  return api.updateOnboardingStateFlowType(data).then(response => {
    if (shouldUpdateRedux) dispatch(updateOnboardingStateSuccess(response.data));
  });
};

export const updateOnboardingState = ({ onboardingState, shouldUpdateRedux = true }) => dispatch => {
  const data = {
    onboarding_state: onboardingState,
  };
  return api.updateOnboardingState(data).then(response => {
    if (shouldUpdateRedux) dispatch(updateOnboardingStateSuccess(response.data));
  });
};

export const updateTopicsInRedux = topics => dispatch => {
  dispatch(updateTopicInReduxSuccess(topics));
};

export const backOnboardingStateAction = () => dispatch =>
  api.backOnboardingState().then(
    response => {
      dispatch(backOnboardingStateSuccess(response.data));
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const submitThirdPartyBrowserEmailAction = ({ email }) =>
  api.submitThirdPartyBrowserEmail({ email }).then(response => response);

export const fetchAgendaAiSlackChannels = () => api.fetchAgendaAiSlackChannels().then(response => response);

export const generateAgendaAiSuggestionsPoll = params =>
  api
    .generateAgendaAiSuggestionsPoll(params)
    .then(response => response)
    .catch(error => {
      WpToastManager.danger('An error occurred. Please try again.');
      return error;
    });

export const generateAgendaAiSuggestionsManual = data => {
  return api.generateAgendaAiSuggestionsManual(data).then(response => {
    return response;
  });
};

export const generateAgendaAiSuggestions = ({ channelIds }) => {
  return api.generateAgendaAiSuggestions({ channelIds }).then(response => {
    return response;
  });
};
